import { createContext } from 'react';

const SnackBarContext = createContext(null);
export default SnackBarContext;
